var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var CommentService = /** @class */ (function (_super) {
            __extends(CommentService, _super);
            function CommentService($http) {
                var _this = _super.call(this, $http) || this;
                _this.$http = $http;
                return _this;
            }
            CommentService.prototype.createNewCommentThreadEntry = function (commentDto) {
                this.handlerUrl = "api/ManageProcess/ProcessComment";
                return this.usePostHandler(commentDto);
            };
            CommentService.prototype.createNewUserActionCommentReply = function (commentDto) {
                this.handlerUrl = "api/ManageProcess/UserActionComment";
                return this.usePostHandler(commentDto);
            };
            CommentService.prototype.deleteComment = function (processId, commentId) {
                return this.$http.post('./api/Process/' + processId + '/DeleteComment/' + commentId, null);
            };
            return CommentService;
        }(services.HttpHandlerService));
        services.CommentService = CommentService;
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService('CommentService', ['$http']);
